module.exports = __webpack_public_path__ + "img/pexels-thirdman-6732658.2ac3d16d.jpg";